module.exports = __webpack_public_path__ + "media/images/analytics-nav-icon-hover-01f7558b28baf52c931a70e4dbbb224c.svg";